var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"top"},[_c('div',{staticClass:"t-t1"},[_vm._v("联系我们")]),_c('div',{staticClass:"t-t2box"},[_c('input',{attrs:{"type":"text","placeholder":"请输入您要查询的代理商/加盟商名称"}}),_c('div',{staticClass:"chaxun"},[_vm._v("查询")])])])])
}]

export { render, staticRenderFns }